/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React from 'react';
import {
  FilterDialog,
  DataYearTab,
  ConditionTab,
  PrimaryConditionSection,
  AdditionalConditionSection,
  StatisticTab,
  SexTab,
  RaceTab,
  AgeTab,
  AggregatedDemographicTab,
  AggregatedSexTab,
  AggregatedRaceTab,
  AggregatedAgeTab,
  GeoLevelTab,
  PrioritizedConditionSection,
  ConsumptionGroupTab,
} from 'nmqf-common-ui';

interface IndexFilterDialogProps {
  isOpen: boolean;
  toggle: () => void;
  defaultActiveTab?: string;
}

export const IndexFilterDialog: React.FC<IndexFilterDialogProps> = (props) => {
  return (
    <FilterDialog
      isOpen={props.isOpen}
      toggle={props.toggle}
      defaultActiveTab={props.defaultActiveTab || DataYearTab.defaultProps?.tabId}
    >
      <DataYearTab />
      <ConditionTab>
        <PrimaryConditionSection />
        <PrioritizedConditionSection />
        <AdditionalConditionSection />
      </ConditionTab>
      <ConsumptionGroupTab />
      <StatisticTab />
      <GeoLevelTab />
      <SexTab />
      <RaceTab />
      <AgeTab />
      <AggregatedDemographicTab />
      <AggregatedSexTab />
      <AggregatedRaceTab />
      <AggregatedAgeTab />
    </FilterDialog>
  );
};
